interface Props {
  activo: boolean;
  alCambiar: () => void;
  etiqueta: string;
  deshabilitado?: boolean;
}

export function Interruptor({ activo, alCambiar, etiqueta, deshabilitado = false }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={activo}
      aria-label={etiqueta}
      disabled={deshabilitado}
      onClick={alCambiar}
      className={[
        'relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200',
        activo ? 'bg-marca-500' : 'bg-armazon-300',
        deshabilitado ? 'cursor-not-allowed opacity-50' : '',
      ].join(' ')}
    >
      <span
        className={[
          'inline-block size-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200',
          activo ? 'translate-x-[18px]' : 'translate-x-[3px]',
        ].join(' ')}
      />
    </button>
  );
}
